const CourseTitleMsg = () => (
  <>
    <span className="inline-block rotate-6">コ</span>
    <span className="inline-block -rotate-6">ー</span>
    <span className="inline-block rotate-6">ス</span>
  </>
);

const LearTitleMsg = () => (
  <>
    <span className="inline-block -rotate-6">ま</span>
    <span className="inline-block rotate-6">な</span>
    <span className="inline-block rotate-6">ぶ</span>
  </>
);

export const TopTitle = () => (
  <div className="flex-col-el flex-center w-[800px] h-[114px] absolute z-50 scale-[1.5]">
    <div className="flex-row-center gap-2">
      <p className="flex-row-el flex-center title-text !text-[100px] -tracking-[0.1em] whitespace-pre text-center text-textcolor-black !mb-[200px]">
        <span
          className="inline-block leading-0 z-10"
          style={{
            WebkitTextStroke: "12px #FEFDFE",
            position: "absolute",
          }}
        >
          <CourseTitleMsg />
        </span>
        <span
          className="inline-block leading-0 z-10"
          style={{
            WebkitTextStroke: "0",
            position: "absolute",
          }}
        >
          <CourseTitleMsg />
        </span>
        <CourseTitleMsg />
      </p>
      <p className="flex-row-el flex-center title-text !text-[60px] -tracking-[0.1em] !mt-8 whitespace-pre text-center text-textcolor-black !mb-[200px]">
        <span
          className="inline-block leading-0 z-10"
          style={{
            WebkitTextStroke: "12px #FEFDFE",
            position: "absolute",
          }}
        >
          <span className="inline-block rotate-6">で</span>
        </span>
        <span
          className="inline-block leading-0 z-10"
          style={{
            WebkitTextStroke: "0",
            position: "absolute",
          }}
        >
          <span className="inline-block rotate-6">で</span>
        </span>
        <span className="inline-block rotate-6">で</span>
      </p>
      <p
        style={{
          WebkitTextStroke: "24px #FFA03B",
        }}
        className="flex-row-el flex-center title-text !text-[100px] -tracking-[0.1em] whitespace-pre text-center text-green-100 !ml-[120px] !mt-[200px]"
      >
        <span
          className="inline-block leading-0 z-10"
          style={{
            WebkitTextStroke: "12px #FEFDFE",
            position: "absolute",
          }}
        >
          <LearTitleMsg />
        </span>
        <span
          className="inline-block leading-0 z-10"
          style={{
            WebkitTextStroke: "0",
            position: "absolute",
          }}
        >
          <LearTitleMsg />
        </span>
        <LearTitleMsg />
      </p>
    </div>
  </div>
);
